import { pipe, zip } from 'remeda';
import { isIdEq } from './is';
export function isCommodityCombinationEq(a, b) {
    const anyFalse = pipe(zip(a, b), (data) => data.some(([a, b]) => !isIdEq(a.variant, b.variant) ||
        a.attribute !== b.attribute));
    return !anyFalse;
}
